import React from 'react';
import classNames from "classnames";
import styles from './XComboBox.module.scss';
import { ETheme } from '../../../types/enums/ETheme';
import { XControl } from '../../commons/XControl';
import { EPosition } from '../../../types/enums/EPosition';
import { IComboBoxItemProps } from './IComboBoxItemProps';
import { XComboBoxItem } from './XComboBoxItem';
import { IComboBoxProps } from './IComboBoxProps';
import { IComboBoxState } from './IComboBoxState';
import { XDropDown } from './XDropDown';




export class XComboBox extends XControl<HTMLDivElement, IComboBoxProps, IComboBoxState> {

    protected editorReference: React.RefObject<HTMLDivElement>;
    //protected selected?: React.ReactElement<IComboBoxItemProps>;

    static defaultProps = {
        ...XControl.defaultProps,
        theme: ETheme.Blue,
        position: undefined,
        editable: false
    }

    public constructor(props: IComboBoxProps) {
        super(props);        

        this.state = {
            ...this.state,
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme,
            position: undefined,
            filter: ''
            //text: this.selected?.props.value;
        };
        this.setPosition = this.setPosition.bind(this);
        this.setText = this.setText.bind(this);
        this.setFilter = this.setFilter.bind(this);
        
        this.onClick = this.onClick.bind(this);
        this.onClickEdit = this.onClickEdit.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClickItem = this.onClickItem.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.setSelected = this.setSelected.bind(this);        
        this.editorReference = React.createRef<HTMLDivElement>();
    }

    private setFilter(value: string) {
        this.setState({filter: value});
    }

    private setSelected(value: XComboBoxItem) {
        this.setState({selected: value});
    }

    private setPosition(value?: EPosition): void {
        this.setState({position: value});
    }

    private setText(value: any) {
        this.setState({text: value})
    }

    public componentDidMount(): void {
        super.componentDidMount();
        const selected: React.ReactElement<IComboBoxItemProps> = this.props.children?.find(x=>{
            const item = x as unknown as XComboBoxItem;
            if(!item)
                return false;
            return item.props.default;
        }) as React.ReactElement<IComboBoxItemProps>;
        this.setSelected(selected as unknown as XComboBoxItem);
    }
    
    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }

    private onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        console.log('ComboBox->onClick');
        this.props.onClick?.(this);
        this.editorReference.current?.focus();
    }

    private onClickEdit(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        console.log('ComboBox->onClickEdit');
    }

    private onKeyDown(event: React.KeyboardEvent<HTMLDivElement>): void {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
        this.setText(this.editorReference.current?.textContent);        
    }

    private onFocus(event: React.FocusEvent<HTMLDivElement>): void {
        console.log(`ComboBox->onFocus ${event.currentTarget.classList} ${event.target.classList} ${event.relatedTarget?.classList}`);
        this.setPosition(EPosition.Bottom);
    }

    private onBlur(event: React.FocusEvent<HTMLDivElement>): void {
        console.log(`ComboBox->onBlur ${event.currentTarget.classList} ${event.target.classList} ${event.relatedTarget?.classList}`);
        this.setPosition(undefined);
    }

    private placeCaretAtEnd(el: HTMLElement) {
        if (!el) return;
        // Фокус обязателен для iOS/Safari
        el.focus();
        // Если элемент пуст — вставим пустой текстовый узел,
        // чтобы каретке было куда "встать".
        if (!el.firstChild) {
            el.appendChild(document.createTextNode(""));
        }
        const selection = window.getSelection();
        const range = document.createRange();
        if (!selection || !range) return;

        // Выделяем всё содержимое и сжимаем в конец
        range.selectNodeContents(el);
        range.collapse(false); // false = в конец

        selection.removeAllRanges();
        selection.addRange(range);
    }

    private onClickItem(item: XComboBoxItem): void {
        this.setSelected(item);
        this.setText(item.props.children);
        this.setPosition(undefined);
        const element = this.editorReference.current;
        if(element)
            this.placeCaretAtEnd(element);
    }
    private onFilter(value?: string | null): void {
        const text = value? value : '';
        this.setFilter(text);
    }

    public render(): React.ReactNode {
        return (
            <div
                ref={this.reference}
                className={classNames(styles.XComboBox)}
                onClick={this.onClick}
                onMouseDown={() => {return false}}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
            >
                <div
                    ref={this.editorReference}
                    className={styles.XEdit}
                    contentEditable={this.props.editable}
                    suppressContentEditableWarning={this.props.editable}
                    tabIndex={0}
                    onKeyDown={this.onKeyDown}
                    //onClick={this.onClickEdit}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                >
                    {this.state.selected?.props.children}
                </div>
                {
                true 
                //this.state.orientation 
                && <XDropDown
                        position={this.state.position}
                        seeker={this.props.seeker}
                        children={this.props.children?.filter(x=>x.props.children?.toString().includes(this.state.filter))}
                        onClickItem={this.onClickItem}
                        onSeekerText={this.onFilter}
                        theme={ETheme.Default}
                    />}
            </div>
        );
    }
}
